import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../contexts'
import { AccessDeniedPage } from './AccessDeniedPage'

interface AdminRouteProps {
  children: React.ReactNode
  fallback?: React.ReactNode
}

export const AdminRoute: React.FC<AdminRouteProps> = ({ 
  children, 
  fallback = <AccessDeniedPage />
}) => {
  const { user, isAuthenticated, isLoading } = useAuth()

  // Show loading while checking authentication
  if (isLoading) {
    return <div>Loading...</div>
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // Check if user is admin
  if (user?.role?.name !== 'admin') {
    return <>{fallback}</>
  }
  

  // User is authenticated and is admin, render the protected content
  return <>{children}</>
}
